import ExpressionPage from '../store/schema/ExpressionPage';
import ExpressionPickerViewState from '../store/schema/ExpressionPickerViewState';
import getGifSearchResults from '../services/getGifSearchResults';
import getPopularEmoji from '../utils/getPopularEmoji';
import matchEmoji from '../utils/matchEmoji';
import { action } from 'satcheljs/lib/legacy';

export default action('updateSearch')(async function updateSearch(
    state: ExpressionPickerViewState,
    searchTerm: string,
    isSmartSuggestions: boolean = false
) {
    if (searchTerm == state.searchTerm) {
        return;
    }

    state.isSearching = true;
    state.searchTerm = searchTerm;

    if (searchTerm) {
        try {
            state.gifPickerViewState.gifResults = await getGifSearchResults(
                searchTerm,
                state.gifPickerViewState.culture,
                isSmartSuggestions
            );
        } catch {
            state.gifPickerViewState.gifResults = null;
        }

        state.emojiPickerViewState.emojiResults = matchEmoji(searchTerm);

        if (searchTerm.trim() != '' && state.page != ExpressionPage.Gifs) {
            state.numSearchesToInsertEmoji++;
        }
    } else {
        state.gifPickerViewState.gifResults = null;
        state.emojiPickerViewState.emojiResults = getPopularEmoji();
    }

    state.isSearching = false;
});
